export default "__VITE_ASSET__CSuCwTkg__"